

















































import {Vue, Component, VModel} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import {CreateServicePayload} from "@/components/payroll/business/services/ServiceDTO";
import {ifValid, processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import ServiceOrchestrator from "@/services/ServiceOrchestrator";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import {v4 as uuidv4} from "uuid";

@Component({
	components: {PortalInput, PortalCheckbox, RightSideBar}
})
export default class ServiceCreationSlider extends Vue {

	@VModel({type: Boolean, default: false})
	private model!: boolean

	private id = uuidv4().toString()

	private req = new CreateServicePayload(
		{
			companyId: this.$wss.getCurrent.type === "COMPANY" ? this.$wss.getCurrent.id : null,
			personId: this.$wss.getCurrent.type === "PERSON" ? this.$wss.getCurrent.id : null
		}
	)

	private save() {
		ifValid(this, () => {
			Application.startLoading();
			ServiceOrchestrator.createService(this.req).then(
				(res) => {
					this.$emit("created", res.data);
					this.$emit("input", false)
					Application.stopLoading();
				},
				err => processError(err, this)
			)
		})
	}

}
